/*!
 * Kallov Hair. The Mirror.
 * Copyright (c) 2026 Kallov Hair. All rights reserved.
 * KALLOV, THE MIRROR and FIND YOUR GIRLIE are trademarks of Kallov Hair.
 * This file, and the methods it implements, are the original work of
 * Kallov Hair. It is served to browsers so that the tool can run. Serving
 * it is not a licence to copy, adapt or redistribute it.
 */
/* Kallov: two corrections to Find Your Girlie.

   1. Advancing a question left you where you were standing.

      kallov-find-your-girlie.js contains no scrollIntoView, no scrollTo and no
      focus() call anywhere. So pressing Continue swapped the question in place
      while the page stayed scrolled to wherever the button happened to be,
      which on a phone is the bottom. The next question rendered above the fold
      and the reader saw nothing move.

      This puts the question back under the header on every stage change, and
      moves focus to it so a screen reader announces it.

   2. "Edit" was doing too much work.

      The result, the act of answering, the saved session and the share link
      were all called an edit. Replaced with the house word.

   Applied here rather than inside the quiz bundle so the bundle stays the
   single source of the logic. Fold it in when that file is next rewritten. */

(function () {
  var quiz = document.querySelector('kallov-match-quiz');
  if (!quiz) return;

  /* ---------- 2. copy ---------- longest first, so the short one cannot
     swallow a phrase it is only part of. */
  var COPY = [
    ['Your Kallov edit is not currently available for delivery to',
     'Your Kallov piece is not currently available for delivery to'],
    ['You started an edit in this session.', 'You started this on an earlier visit.'],
    ['was saved from an earlier edit.', 'was saved from an earlier visit.'],
    ['Your edit is ready.', 'Your Girlie is ready.'],
    ['Copy my edit link', 'Copy my link'],
    ['A balanced edit', 'A balanced match'],
    ['a balanced edit', 'a balanced match'],
    ['Resume the edit', 'Pick up where I left off'],
    ['Show my edit', 'Show my Girlie'],
    ['Exit the edit', 'Leave'],
    ['Leave the edit', 'Leave'],
    ['Your edit', 'Your Girlie'],
    /* Every wig is made to order. The bundle still says ready to wear ships
       with no wait; these two lines say what is true until it is rewritten. */
    ['Shipped as she is, with no wait.', 'A finished design, made in your size. About 21 days.'],
    /* Every wig is made to order, so "made to order" cannot also be the name
       of the bespoke line. The bundle still uses it that way; these say Bespoke. */
    ['Open to Made-to-Order', 'Open to Bespoke'],
    ['Made to order rather than ready to wear.', 'Bespoke rather than ready to wear.'],
    ['Ready to wear rather than made to order.', 'Ready to wear rather than bespoke.'],
    ['She is made to order in your measurements', 'She is built to your measurements'],
    ['a piece made to order', 'a bespoke piece'],
    ['Made to order. Production runs', 'Bespoke. Production runs']
  ];
  var MTO_ROW = 'Ready to wear. Made to order, about 21 days.';

  function rewrite(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var before = node.nodeValue;
      if (before.indexOf('edit') === -1 && before.indexOf('Edit') === -1 && before.indexOf('no wait') === -1 && before.indexOf('ade to order') === -1 && before.indexOf('ade-to-Order') === -1 && before !== 'Ready to wear') continue;
      var after = before;
      for (var i = 0; i < COPY.length; i++) {
        after = after.split(COPY[i][0]).join(COPY[i][1]);
      }
      if (after === 'Ready to wear') after = MTO_ROW;
      if (after === 'Made to order') after = 'Bespoke. Built to your measurements.';
      if (after !== before) node.nodeValue = after;
    }
    var labelled = root.querySelectorAll ? root.querySelectorAll('[aria-label]') : [];
    for (var j = 0; j < labelled.length; j++) {
      var a = labelled[j].getAttribute('aria-label'), b = a;
      for (var k = 0; k < COPY.length; k++) b = b.split(COPY[k][0]).join(COPY[k][1]);
      if (b !== a) labelled[j].setAttribute('aria-label', b);
    }
  }

  /* ---------- 1. position ---------- */
  var settling = false;

  function headerHeight() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  }

  /* The target is the question itself, not the stage.

     The stage is the whole split: on a phone the stand photograph stacks above
     the panel, so putting the stage under the header put the picture on screen
     and the question below the fold. The reader is here to answer, so the
     question is what has to be at the top. */
  function questionOf(stage) {
    return stage.querySelector('[data-kq-form]')
        || stage.querySelector('[data-kq-result]')
        || stage.querySelector('.kallov-quiz__panel')
        || stage;
  }

  function bringToTop() {
    if (settling) return;
    settling = true;
    requestAnimationFrame(function () {
      var stage = quiz.querySelector('.kallov-quiz__stage[data-active]') || quiz;
      var target = questionOf(stage);
      var top = target.getBoundingClientRect().top + window.scrollY - headerHeight() - 16;
      if (Math.abs(window.scrollY - top) > 8) {
        window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
      }
      var heading = target.querySelector('.kallov-quiz__question, h1, h2')
                 || stage.querySelector('.kallov-quiz__question, h1, h2');
      if (heading) {
        if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
        try { heading.focus({ preventScroll: true }); } catch (e) { heading.focus(); }
      }
      settling = false;
    });
  }

  /* Focusing the heading is what makes a screen reader announce the new
     question. It also draws the browser's focus ring, and this element is
     never reachable by Tab, so the ring has no one to serve. */
  var ring = document.createElement('style');
  ring.textContent = 'kallov-match-quiz [tabindex="-1"]:focus{outline:none;}';
  document.head.appendChild(ring);

  rewrite(quiz);

  /* Only a new stage or a newly rendered question is a reason to move the page.
     Every other mutation is left alone. The cap note on the two-choice question
     ("Two is the limit") rewrites its own text, and treating that as a stage
     change scrolled the page out from under her thumb while she was choosing. */
  function isQuestion(n) {
    if (!n || n.nodeType !== 1) return false;
    if (n.classList && n.classList.contains('kallov-quiz__fieldset')) return true;
    return !!(n.querySelector && n.querySelector('.kallov-quiz__fieldset'));
  }

  var mo = new MutationObserver(function (records) {
    var moved = false;
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.type === 'attributes' && r.attributeName === 'data-active') moved = true;
      if (r.type === 'childList' && r.addedNodes.length) {
        for (var j = 0; j < r.addedNodes.length; j++) {
          var n = r.addedNodes[j];
          if (isQuestion(n)) moved = true;
          if (n.nodeType === 1 || n.nodeType === 3) rewrite(n.nodeType === 1 ? n : n.parentNode || quiz);
        }
      }
    }
    if (moved) bringToTop();
  });

  mo.observe(quiz, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-active'] });
})();

/* Kallov: The Hands That Style, the Honeybee spread.

   Their photograph is landscape, so it is set into the text like a magazine
   page: the names and the opening paragraph run the full measure, then the
   picture drops in on the right from the first paragraph and the rest of the
   words wrap around it. The split section always renders the figure
   before or after the whole prose block, so this moves it to just before
   the first paragraph; the float itself is section 6 of kallov-late-fix.css
   and only applies on desktop. */
(function () {
  var section = document.querySelector('[id$="__honeybee"]');
  if (!section) return;
  var figure = section.querySelector('.k-split__media');
  var body = section.querySelector('.k-body');
  if (!figure || !body) return;
  var target = null;
  var paras = body.querySelectorAll(':scope > p');
  for (var i = 0; i < paras.length; i++) {
    if (/^Every color that leaves this house/.test(paras[i].textContent.trim())) { target = paras[i]; break; }
  }
  if (!target) return;
  body.insertBefore(figure, target);
  section.classList.add('k-magazine');
})();

/* Kallov: the hairline map travels with the order.

   The Mirror (/pages/mirror) saves a small hairline map on the phone. On any
   product page this reads it back and attaches it to the main product form
   as a line item property, so it lands on the order in admin the way the
   bespoke specification does. A short note tells her it is there and lets
   her leave it off. Nothing is sent anywhere until she adds to cart. */
(function () {
  var KEY = 'kallovHairline';
  if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(location.pathname)) return;
  var saved = null;
  try { saved = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { saved = null; }

  /* The map writes itself to her phone as soon as there is a reading, but
     it only leaves the phone once she has ticked the box in The Mirror.
     A map she has not agreed to send is held back here and she is told
     where the tick is, rather than it silently never arriving. */
  var withheld = !!(saved && saved.map && saved.map.consent === false);
  if (withheld) saved = null;

  function idOf(el) { return el ? el.getAttribute('id') || '' : ''; }
  function hostFor(form) {
    var spec = document.querySelector('[data-kspec]'), host = null;
    if (spec) {
      var legends = spec.querySelectorAll('.kspec__legend');
      for (var i = 0; i < legends.length; i++) {
        if (/hairline/i.test(legends[i].textContent)) { host = legends[i].parentNode; break; }
      }
    }
    return host;
  }
  var style = document.createElement('style');
  style.textContent = '.k-hairline-note{margin:14px 0 0;line-height:1.6}.k-hairline-note__btn{background:none;border:0;padding:0;margin-left:6px;font:inherit;color:inherit;text-decoration:underline;cursor:pointer}.k-hairline-note a{color:inherit;text-decoration:underline;text-underline-offset:3px}';
  document.head.appendChild(style);

  /* No map on this phone: the door to The Mirror, in the same place the
     note would sit. */
  if (!saved || !saved.text) {
    var invite = function () {
      var form = mainForm();
      if (!form || document.querySelector('[data-k-hairline-invite]')) return;
      var p = document.createElement('p');
      p.className = 'k-small k-hairline-note';
      p.setAttribute('data-k-hairline-invite', '');
      p.innerHTML = withheld
        ? 'Your hairline map is saved on this phone but not attached to your order yet. Open <a href="/pages/mirror">The Mirror</a> and tick the box to send it with your piece.'
        : 'Show us your hairline in <a href="/pages/mirror">The Mirror</a> and we customize her hairline, lace tint and knots to you.';
      var host = hostFor(form);
      if (host) host.appendChild(p); else form.parentNode.insertBefore(p, form.nextSibling);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', invite, { once: true });
    else invite();
    return;
  }
  function mainForm() {
    var forms = document.querySelectorAll('form.shopify-product-form'), fallback = null;
    for (var i = 0; i < forms.length; i++) {
      var id = idOf(forms[i]);
      if (!id || id.indexOf('installment') !== -1 || id.indexOf('sticky') !== -1 || id.indexOf('quick-buy') !== -1) continue;
      if (id.indexOf('product-form-main-') === 0) return forms[i];
      if (!fallback) fallback = forms[i];
    }
    return fallback;
  }

  function attach() {
    var form = mainForm();
    if (!form || document.querySelector('[data-k-hairline]')) return;
    var input = document.createElement('input');
    input.type = 'hidden'; input.name = 'properties[Hairline map]'; input.value = saved.text;
    input.setAttribute('form', idOf(form)); input.setAttribute('data-k-hairline', '');
    form.appendChild(input);

    var note = document.createElement('p');
    note.className = 'k-small k-hairline-note';
    note.setAttribute('data-k-hairline-note', '');
    var sk = saved.map && saved.map.skin;
    note.innerHTML = 'Your hairline map from The Mirror (' + (saved.map && saved.map.at ? saved.map.at : '') +
      ') goes with this order. We customize her hairline' + (sk ? ', lace tint and knots' : '') + ' to you.' +
      ' <button type="button" class="k-hairline-note__btn" data-k-hairline-off>Leave it off</button>';

    /* On a bespoke specification, the map answers what it can, and only where
       she has not answered herself. */
    var spec = document.querySelector('[data-kspec]');
    if (spec) {
      var pick = function (name, value) {
        if (spec.querySelector('input[name="' + name + '"]:checked')) return;
        var r = spec.querySelector('input[name="' + name + '"][value="' + value + '"]');
        if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      };
      var f = saved.map && saved.map.fullness;
      if (f && typeof f.C === 'number') {
        var d = Math.round((f.L + f.C + f.R) / 3);
        pick('properties[Baby hair density]', d <= 2 ? 'Scanty' : d === 3 ? 'Light' : 'Thick');
      }
    }

    var host = hostFor(form);
    if (host) host.appendChild(note);
    else form.parentNode.insertBefore(note, form.nextSibling);

    note.querySelector('[data-k-hairline-off]').addEventListener('click', function () {
      input.remove();
      note.textContent = 'Left off. Open The Mirror to save a new one.';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, { once: true });
  else attach();
})();

/* Kallov: The Mirror inside Find Your Girlie.

   The mirror section is placed on the finder page with "Inside Find Your
   Girlie" ticked, which renders it hidden. This moves it into the quiz as a
   stage of its own, offered from the result. The camera is never required
   anywhere on the site.

   Corrected 11 September 2026. It used to sit BEFORE the reveal and hold it
   back until she pressed skip or continue. That made "Show my Girlie" open a
   full-height camera instead of a Girlie, with the way out below the fold, so
   most people never reached their result at all. The reveal now happens the
   moment she finishes the questions, exactly as it did before The Mirror
   existed, and the mirror is offered on the result instead. It is still one
   tap away and it still rides along to the product page; it is no longer a
   gate across the only thing she came for.

   The saved map rides along to the product page as before. It recommends
   nothing. Alexis, 12 September 2026: "The mirror is not built to recommend any
   hair styles or wigs. It is solely a tool for our colorists, stylists and wig
   makers to utilize." The questionnaire picks the Girlie; the map tells the
   bench how to build her. */
/* ---------------------------------------------------------------------
   A net under the catalog.

   13 September 2026. Find Your Girlie stopped choosing anybody. The cause was
   one character: the pool array in the section opened with a stray comma,
   because products that are not quiz enabled are skipped with `continue` while
   the separator was still keyed off forloop.first. Invalid JSON, so the quiz's
   own `readJSON` caught the parse error, returned null, and the catalog came up
   empty. An empty catalog cannot match anybody, so every answer led to "Not
   yet."

   The section is fixed. This is the net, because the quiz failing silently is
   the part that cost the days, not the comma. If the catalog is empty and the
   pool node has content in it, repair the commas, parse again, and say so in
   the console. A quiz that cannot read its catalog should be loud.
   --------------------------------------------------------------------- */
(function () {
  var q = document.querySelector('kallov-match-quiz');
  if (!q) return;
  var repair = function () {
    if (!q.catalog || q.catalog.length) return;
    var node = q.querySelector('[data-kq-pool]');
    if (!node) return;
    var raw = (node.textContent || '').trim();
    if (raw.length < 3) return;
    var mended = raw.replace(/\[\s*,+/, '[').replace(/,+\s*\]/, ']').replace(/,\s*,+/g, ',');
    var parsed = null;
    try { parsed = JSON.parse(mended); } catch (e) { parsed = null; }
    if (parsed && parsed.length) {
      q.catalog = parsed;
      if (window.console && console.warn) console.warn('Kallov: the Girlie catalog was malformed and has been repaired in the browser. Fix the section, do not rely on this.');
    } else if (window.console && console.error) {
      console.error('Kallov: the Girlie catalog could not be read at all. Find Your Girlie cannot choose anybody.');
    }
  };
  repair();
  setTimeout(repair, 0);
  document.addEventListener('DOMContentLoaded', repair);
})();

(function () {
  var quiz = document.querySelector('kallov-match-quiz');
  var section = document.querySelector('[data-km-embed]');
  if (!quiz || !section) return;
  var KEY = 'kallovHairline';
  var cfgNode = section.querySelector('[data-km-config]');
  var cfg = {};
  try { cfg = JSON.parse(cfgNode.textContent); } catch (e) { cfg = {}; }

  function readMap() {
    try { var s = JSON.parse(localStorage.getItem(KEY) || 'null'); return s && s.map ? s : null; } catch (e) { return null; }
  }

  /* The stage. */
  var root = quiz.querySelector('.kallov-quiz');
  var stage = document.createElement('section');
  stage.className = 'kallov-quiz__stage kallov-quiz__stage--mirror';
  stage.setAttribute('data-kq-mirror', '');
  var reveal = quiz.querySelector('[data-kq-reveal]');
  if (reveal && reveal.parentNode === root) root.insertBefore(stage, reveal.nextSibling); else root.appendChild(stage);
  stage.appendChild(section);

  var css = document.createElement('style');
  css.textContent = '.kallov-quiz__stage--mirror .km-section{margin-inline:0}.kallov-quiz__stage--mirror .k-wrap{max-width:1240px}.kallov-quiz__mirror-note{margin:18px 0 0;font-size:15px;line-height:1.65}.kallov-quiz__mirror-note a{color:inherit}.kallov-quiz__mirror-lead{display:block;margin-bottom:12px}[data-kq-mirror-open] .kallov-quiz__button{display:inline-flex}';
  document.head.appendChild(css);

  var cameFromResult = false;   // so we know where to go back to

  function titleOf(handle) {
    var pool = [];
    try { pool = JSON.parse(quiz.querySelector('[data-kq-pool]').textContent); } catch (e) {}
    for (var i = 0; i < pool.length; i++) if (pool[i].handle === handle) return pool[i];
    if (!handle || handle === '_') return null;
    return { handle: handle, title: handle.charAt(0).toUpperCase() + handle.slice(1), url: '/products/' + handle };
  }
  /* The face shape tilt is gone. Alexis, 12 September 2026: "There's no need
     to scan for the face shape. Face shape is unnecessary." The model's own
     answer stands, and the map contributes her undertone and her lace tint,
     which are things the house acts on rather than a hook. */
  function tilt(res) { return res; }

  function noteFor(res) {
    var saved = readMap();
    if (!saved) return '';
    /* What the note may never do is claim the map is travelling with her order
       when she has not agreed to that. */
    var t = saved.map.consent === false
      ? 'Your hairline map is on this phone. Tick the box in The Mirror and it goes with your order, and we customize her hairline, lace tint and knots to you.'
      : 'Your hairline map goes with her. We customize her hairline, lace tint and knots to you.';
    return t;
  }

  customElements.whenDefined('kallov-match-quiz').then(function () {
    var proto = Object.getPrototypeOf(quiz);
    var origShow = proto.show, origReveal = proto.reveal, origRestart = proto.restart, origRender = proto.renderResult;

    proto.show = function (which) {
      stage.removeAttribute('data-active');
      return origShow.call(this, which);
    };

    proto.restart = function () {
      cameFromResult = false;
      return origRestart.apply(this, arguments);
    };

    /* Open the mirror as a stage of its own, from the result. */
    var mapOnOpen = null;
    function openMirror() {
      cameFromResult = true;
      mapOnOpen = readMap() ? JSON.stringify(readMap().map.ys || '') : null;
      quiz.show(stage);
      var h = section.querySelector('[data-km-heading]');
      if (h) { try { h.focus({ preventScroll: true }); } catch (e) {} }
      if (quiz.live) quiz.live.textContent = 'Show us your hairline, or go back to your Girlie.';
    }

    proto.renderResult = function (result) {
      var out = origRender.call(this, result);
      var host = this.revealStage && this.revealStage.querySelector('[data-kq-result]');
      var text = noteFor(result);
      if (host && text && !host.querySelector('[data-kq-mirror-note]')) {
        var note = document.createElement('p');
        note.className = 'kallov-quiz__support kallov-quiz__mirror-note';
        note.setAttribute('data-kq-mirror-note', '');
        note.innerHTML = text;
        var why = host.querySelector('.kallov-quiz__result-why');
        if (why && why.parentNode === host) host.insertBefore(note, why.nextSibling); else host.appendChild(note);
        var motion = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        if (motion) {
          note.style.opacity = '0';
          setTimeout(function () { note.style.transition = 'opacity 420ms cubic-bezier(0.22,0.61,0.36,1)'; note.style.opacity = '1'; }, 1900);
        }
      }

      /* The invitation, under her Girlie rather than in front of her. */
      if (host && !host.querySelector('[data-kq-mirror-open]')) {
        var saved = readMap();
        var row = document.createElement('p');
        row.className = 'kallov-quiz__support kallov-quiz__mirror-note';
        row.setAttribute('data-kq-mirror-open', '');
        var open = document.createElement('button');
        open.type = 'button';
        open.className = 'kallov-quiz__button kallov-quiz__button--ghost';
        open.textContent = saved ? 'Update my hairline map' : 'Show us your hairline';
        open.addEventListener('click', function () { quiz.emit && quiz.emit('mirror_opened'); openMirror(); });
        if (!saved) {
          var lead = document.createElement('span');
          lead.className = 'kallov-quiz__mirror-lead';
          lead.textContent = 'A minute in The Mirror on your phone, and we customize her hairline, lace tint and knots to you. ';
          row.appendChild(lead);
        }
        row.appendChild(open);
        var anchor = host.querySelector('[data-kq-mirror-note]') || host.querySelector('.kallov-quiz__proof') || host.querySelector('.kallov-quiz__result-why');
        if (anchor && anchor.parentNode === host) host.insertBefore(row, anchor.nextSibling); else host.appendChild(row);
        var m2 = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        if (m2) {
          row.style.opacity = '0';
          setTimeout(function () { row.style.transition = 'opacity 420ms cubic-bezier(0.22,0.61,0.36,1)'; row.style.opacity = '1'; }, 2000);
        }
      }
      return out;
    };

    /* The model's answer, tilted. Patched on the shared model object; the
       quiz calls this.model.match, which is the same object. */
    var M = window.KallovQuizModel;
    if (M && !M._kmTilted) {
      var origMatch = M.match;
      M.match = function (catalog, answers) { return tilt(origMatch.call(M, catalog, answers), answers); };
      M._kmTilted = true;
    }

    /* Leaving the mirror always lands back on her Girlie. If she saved a map,
       the match is run again so the face shape can tilt the pick and the note
       can name her shape and undertone. */
    function finish(saved) {
      if (!cameFromResult) return;
      cameFromResult = false;
      /* The map now writes itself as soon as there is a reading, so she may
         never press save. If one appeared, or changed, while she was in
         there, the match is re-run whichever way she came out. */
      var now = readMap() ? JSON.stringify(readMap().map.ys || '') : null;
      if (now && now !== mapOnOpen) saved = true;
      if (saved) origReveal.call(quiz, false);
      else quiz.show(quiz.revealStage);
      var name = quiz.revealStage.querySelector('.kallov-quiz__result-name');
      if (name) { try { name.focus({ preventScroll: true }); } catch (e) {} }
    }
    var skip = section.querySelector('[data-km-skip]');
    var conts = section.querySelectorAll('[data-km-continue]');
    var prev = section.querySelector('[data-km-use-previous]');
    if (skip) { skip.textContent = 'Back to my Girlie'; skip.addEventListener('click', function () { quiz.emit && quiz.emit('mirror_skipped'); finish(false); }); }
    for (var c = 0; c < conts.length; c++) conts[c].addEventListener('click', function () { quiz.emit && quiz.emit('mirror_saved'); finish(true); });
    if (prev) prev.addEventListener('click', function () { quiz.emit && quiz.emit('mirror_previous'); finish(true); });
    window.kallovOpenMirror = openMirror;
  });
})();
